<mat-card>
  <mat-card-content>
    <form class="form-horizontal" (ngSubmit)="login()">
      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Gebruikersnaam</mat-label>
          <input matInput name="username" placeholder="Gebruikersnaam" required [(ngModel)]="username">
        </mat-form-field>
      </div>
      <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Wachtwoord</mat-label>
        <input matInput name="password" placeholder="Wachtwoord" type="password" required [(ngModel)]="password">
      </mat-form-field>
      </div>
      <button class="w-100 mt-2" mat-button mat-flat-button color="primary"
              (click)="login()">
        Inloggen
      </button>
    </form>
    <p>{{message}}</p>
  </mat-card-content>
</mat-card>
